
// import React, { useEffect, useState } from "react";
// import {Box,Typography,IconButton,Container,Paper,Avatar,Autocomplete,TextField,Chip,CircularProgress,Alert,Card,CardContent,Divider,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { useNavigate } from "react-router-dom";
// import CommonFieldsScreen from "./CommonFields";
// import DiagnosticSample from "../Logos/DiagnoisticDelivery/DiagnosticSampleCollection.png";
// import Footer from "../Common/Footer";
// import { apiRequest } from '../../fetchSetup';

// import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";

// const DIAGNOSTIC_TESTS_API = process.env.REACT_APP_GET_DIAGNOSTIC_TESTS;

// const DiagnosticDeliveryScreen = () => {
//   const navigate = useNavigate();
//   const [user, setUser] = useState(null);
//   const [diagnosticTests, setDiagnosticTests] = useState([]);
//   const [selectedTests, setSelectedTests] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [userLoading, setUserLoading] = useState(true);
//   const [inputValue, setInputValue] = useState("");
//   const [expandedTest, setExpandedTest] = useState(null);
//   useEffect(() => {
//     const fetchUser = async () => {
//       setUserLoading(true);
      
//       const storedUser = sessionStorage.getItem("user");
//       if (storedUser) {
//         const parsedUser = JSON.parse(storedUser);
//         setUser(parsedUser);
//       }

//       const userId = sessionStorage.getItem("userId");
//       const token = sessionStorage.getItem("token");
      
//       if (userId && token) {
//         try {
//           const userData = await fetchUserFromRedis(userId, token);
//           if (userData) {
//             setUser(userData);
//             sessionStorage.setItem("user", JSON.stringify(userData));
//           }
//         } catch (err) {
//           console.error("Error fetching user from Redis:", err);
//         }
//       }
      
//       setUserLoading(false);
//     };

//     fetchUser();
//     fetchDiagnosticTests();
//   }, []);

//   const fetchDiagnosticTests = async () => {
//     try {
//       setLoading(true);
//       const response = await apiRequest(DIAGNOSTIC_TESTS_API);
      
//       if (!response.ok) {
//         throw new Error("Failed to fetch diagnostic tests");
//       }

//       const data = await response.json();
//       setDiagnosticTests(data);
//       setError(null);
//     } catch (err) {
//       console.error("Error fetching diagnostic tests:", err);
//       setError("Failed to load diagnostic tests. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleTestSelection = (event, newValue) => {
//     setSelectedTests(newValue);
//   };

//   const handleRemoveTest = (testToRemove) => {
//     setSelectedTests(selectedTests.filter((test) => test.id !== testToRemove.id));
//   };

//   const calculateTotal = () => {
//     // return selectedTests.reduce((sum, test) => sum + test.mrp, 0);
//     return selectedTests.reduce((sum, test) => sum + (test.non_membership || test.mrp || 0), 0);
//   };
  
//   const calculateMRPTotal = () => {
//     return selectedTests.reduce((sum, test) => sum + test.mrp, 0);
//   };

//   const calculateSavings = () => {
//     return calculateMRPTotal() - calculateTotal();
//   };

//   const handleBackToServices = () => {
//     sessionStorage.removeItem("commonFormData");
//     navigate("/services");
//   };
//   const PREFERRED_TEST_NAMES = [
//     "CBC with ESR",
//     "Liver Function Tests - LFT",
//     "Lipid Profile",
//     "Glucose - Fasting",
//     "HbA1c - Glycated Hemoglobin",
//     "Renal Function Test (RFT) - Basic",
//     "Glucose - Random",
//   ];

//   const getSortedOptions = (options, inputValue) => {
//     const query = inputValue?.toLowerCase().trim() || "";
//     const selectedIds = new Set(selectedTests.map((t) => t.id));
  
//     const preferredIds = new Set(
//       options
//         .filter((o) =>
//           PREFERRED_TEST_NAMES.some((name) =>
//             o.test_name.toLowerCase().includes(name.toLowerCase())
//           )
//         )
//         .map((o) => o.id)
//     );
  
//     const filtered = options.filter((o) => !selectedIds.has(o.id));
  
//     if (!query) {
//       // No search: preferred first, then rest alphabetically
//       const preferred = filtered.filter((o) => preferredIds.has(o.id));
//       const rest = filtered.filter((o) => !preferredIds.has(o.id));
//       return [...preferred, ...rest];
//     }
  
//     // With search: prioritize starts-with, then contains
//     const startsWith = filtered.filter((o) =>
//       o.test_name.toLowerCase().startsWith(query)
//     );
//     const contains = filtered.filter(
//       (o) =>
//         !o.test_name.toLowerCase().startsWith(query) &&
//         o.test_name.toLowerCase().includes(query)
//     );
  
//     return [...startsWith, ...contains];
//   };
//   return (
//     <>
//       <Container maxWidth="md" sx={{ py: 3 }}>
//         <Paper sx={{ p: 3, borderRadius: 3 }}>
//           {/* Header */}
//           <Box mb={3}>
//             <IconButton onClick={handleBackToServices}>
//               <ArrowBackIosNewIcon />
//             </IconButton>
//             <Box display="flex" alignItems="center" mt={4}>
//               <Avatar
//                 src={DiagnosticSample}
//                 alt="DIAGNOSTIC SAMPLE COLLECTION"
//                 sx={{ width: 60, height: 60, borderRadius: 2 }}
//               />
//               <Box ml={2}>
//                 <Typography fontSize={16} fontWeight={700} color="text.primary">
//                   DIAGNOSTIC SAMPLE COLLECTION
//                 </Typography>
//                 <Typography
//                   fontSize={12}
//                   color="text.secondary"
//                   mt={0.5}
//                   sx={{ maxWidth: 220 }}
//                 >
//                   Ayuja Will Choose Right People For The Timing Of Your Selection
//                 </Typography>
//               </Box>
//             </Box>
//           </Box>

//           {/* Test Selection Section */}
//           <Box mb={4}>
//             <Typography fontSize={18} fontWeight={600} mb={2} color="#006D77">
//               Select Diagnostic Tests
//             </Typography>

//             {error && (
//               <Alert severity="error" sx={{ mb: 2 }}>
//                 {error}
//               </Alert>
//             )}

//             {loading ? (
//               <Box display="flex" justifyContent="center" py={4}>
//                 <CircularProgress />
//               </Box>
//             ) : (
//               <>

//                 <Autocomplete
//                   multiple
//                   options={getSortedOptions(diagnosticTests, inputValue)}
//                   value={selectedTests}
//                   onChange={handleTestSelection}
//                   inputValue={inputValue}
//                   onInputChange={(e, newInput) => setInputValue(newInput)}
//                   onClose={() => setExpandedTest(null)}
//                   getOptionLabel={(option) => option.test_name}
//                   filterOptions={(options) => options}
//                   isOptionEqualToValue={(option, value) => option.id === value.id}
//                   groupBy={(option) =>
//                     !inputValue
//                       ? PREFERRED_TEST_NAMES.some((name) =>
//                           option.test_name.toLowerCase().includes(name.toLowerCase())
//                         )
//                         ? "⭐ Recommended Tests"
//                         : "All Tests"
//                       : undefined
//                   }
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       placeholder="Search tests by name..."
//                       variant="outlined"
//                       InputProps={{
//                         ...params.InputProps,
//                         startAdornment: (
//                           <>
//                             <Box component="span" sx={{ color: "#006D77", mr: 1, fontSize: 18, lineHeight: 1 }}>
//                               🔬
//                             </Box>
//                             {/* {params.InputProps.startAdornment} */}
//                           </>
//                         ),
//                       }}
//                     />
//                   )}
//                   renderGroup={(params) => (
//                     <Box key={params.key}>
//                       <Box
//                         sx={{
//                           px: 2,
//                           py: 0.75,
//                           bgcolor:
//                             params.group === "⭐ Recommended Tests" ? "#E0F7F8" : "#F9FAFB",
//                           borderBottom: "1px solid #E5E7EB",
//                           borderTop: "1px solid #E5E7EB",
//                           position: "sticky",
//                           top: 0,
//                           zIndex: 10,
//                         }}
//                       >
//                         <Typography
//                           sx={{
//                             fontSize: 11,
//                             fontWeight: 700,
//                             color:
//                               params.group === "⭐ Recommended Tests" ? "#006D77" : "#6B7280",
//                             textTransform: "uppercase",
//                             letterSpacing: 0.6,
//                           }}
//                         >
//                           {params.group}
//                         </Typography>
//                       </Box>
//                       {params.children}
//                     </Box>
//                   )}
//                   renderOption={(props, option) => {
//                     const { key, ...liProps } = props;
//                     const isPreferred = PREFERRED_TEST_NAMES.some((name) =>
//                       option.test_name.toLowerCase().includes(name.toLowerCase())
//                     );
//                     const hasDiscount =
//                       option.non_membership > 0 && option.non_membership < option.mrp;
//                     const isExpanded = expandedTest === option.id;
                  
//                     return (
//                       <li
//                         key={key}
//                         {...liProps}
//                         style={{ display: "block", padding: 0, listStyle: "none" }}
//                       >
//                         <Box
//                           sx={{ width: "100%", px: 2, pr: 3,py: 1, borderLeft:
//                               isPreferred && !inputValue
//                                 ? "3px solid #006D77"
//                                 : "3px solid transparent",
//                             cursor: "pointer",
//                             transition: "background 0.15s",
//                             "&:hover": { bgcolor: "#F0F9FF" },
//                             boxSizing: "border-box",
//                           }}
//                         >
//                           {/* ── Main Row ── */}
//                           <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={2}
//                             sx={{ width: "100%" }}
//                           >
//                             {/* Left: name + meta */}
//                             <Box flex={1} minWidth={0}>
//                               {/* Recommended badge */}
//                               {isPreferred && !inputValue && (
//                                 <Chip
//                                   label="Recommended"
//                                   size="small"
//                                   sx={{ height: 17, fontSize: 9, fontWeight: 700, bgcolor: "#006D77", color: "white", pointerEvents: "none", mb: 0.5,
//                                     "& .MuiChip-label": { px: 0.75 },
//                                   }}
//                                 />
//                               )}
                  
//                               {/* Test Name */}
//                               <Typography
//                                 fontSize={14}
//                                 fontWeight={600}
//                                 color="#111827"
//                                 sx={{ lineHeight: 1.4, wordBreak: "break-word" }}
//                               >
//                                 {option.test_name}
//                               </Typography>
                  
//                               {/* Category */}
//                               {option.category && (
//                                 <Typography fontSize={11} color="text.secondary" sx={{ mt: 0.25 }}>
//                                   {option.category}
//                                 </Typography>
//                               )}
                  
//                               {/* About toggle */}
//                               {option.description && (
//                                 <Box
//                                   component="span"
//                                   onMouseDown={(e) => e.preventDefault()}
//                                   onClick={(e) => {
//                                     e.preventDefault();
//                                     e.stopPropagation();
//                                     setExpandedTest(isExpanded ? null : option.id);
//                                   }}
//                                   sx={{display: "inline-flex",alignItems: "center",gap: 0.4,mt: 0.75,cursor: "pointer",color: "#006D77",fontSize: 11,fontWeight: 600,userSelect: "none",border: "1px solid #B2E0E4",borderRadius: 1,px: 0.75,py: 0.25,
//                                     bgcolor: isExpanded ? "#E0F7F8" : "transparent",
//                                     transition: "all 0.15s",
//                                     "&:hover": { bgcolor: "#E0F7F8", borderColor: "#006D77" },
//                                   }}
//                                 >
//                                   {isExpanded ? "▲ Hide Details" : "▼ About This Test"}
//                                 </Box>
//                               )}
//                             </Box>
//                           <Box sx={{flexShrink: 0,minWidth: 70,   textAlign: "right",pt: 0.25,}} >
//                               <Typography
//                                 fontSize={14}
//                                 fontWeight={700}
//                                 color="#006D77"
//                                 noWrap     
//                               >
//                                 ₹{(option.non_membership || option.mrp || 0).toFixed(2)}
//                               </Typography>
//                               {hasDiscount && (
//                                 <Typography
//                                   fontSize={11}
//                                   color="text.secondary"
//                                   noWrap
//                                   sx={{ textDecoration: "line-through", lineHeight: 1.4 }}
//                                 >
//                                   ₹{option.mrp}
//                                 </Typography>
//                               )}
//                             </Box>
//                           </Box>
                  
//                           {/* ── Expandable Description ── */}
//                           {isExpanded && option.description && (
//                             <Box
//                               onMouseDown={(e) => e.preventDefault()}
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 e.stopPropagation();
//                               }}
//                               sx={{mt: 1,mb: 0.5,p: 1.5,bgcolor: "#F0F9FF",borderRadius: 1.5,border: "1px solid #B2E0E4",
//                               }}
//                             >
//                               <Typography
//                                 fontSize={11}
//                                 fontWeight={700}
//                                 color="#006D77"
//                                 sx={{ mb: 0.5, textTransform: "uppercase", letterSpacing: 0.4 }}
//                               >
//                                 ℹ️ About This Test
//                               </Typography>
//                               <Typography fontSize={12} color="#374151" sx={{ lineHeight: 1.7 }}>
//                                 {option.description}
//                               </Typography>
//                             </Box>
//                           )}
//                         </Box>
//                       </li>
//                     );
//                   }}
//                   ListboxProps={{
//                     sx: {maxHeight: 400,p: 0,overflowX: "hidden",      
//                       "& .MuiAutocomplete-option": {p: 0,display: "block",minHeight: "unset",   
//                         '&[aria-selected="true"]': {bgcolor: "#E0F7FA",},
//                         "&.Mui-focused": {bgcolor: "#F0F9FF",},
//                       },
//                     },
//                   }}
//                   />

//                 {/* Selected Tests Summary */}
//                 {selectedTests.length > 0 && (
//                   <Card variant="outlined" sx={{ mb: 3 }}>
//                     <CardContent>
//                       <Typography fontSize={16} fontWeight={600} mb={2}>
//                         Selected Tests ({selectedTests.length})
//                       </Typography>

//                       {selectedTests.map((test) => (
//                         <Box
//                           key={test.id}
//                           display="flex"
//                           justifyContent="space-between"
//                           alignItems="center"
//                           py={1.5}
//                           sx={{ borderBottom: "1px solid #f0f0f0" }}
//                         >
//                           <Box flex={1}>
//                             <Typography fontSize={14} fontWeight={600}>
//                               {test.test_name}
//                             </Typography>
//                           </Box>
//                           <Box display="flex" alignItems="center" gap={2}>
//                             <Box textAlign="right">

//                               {/* <Typography
//                                 fontSize={12}
//                                 sx={{  color: "text.secondary" }}
//                               >
//                                 ₹{test.mrp}
//                               </Typography> */}
//                               <Typography fontSize={14} fontWeight={700} color="#006D77">
//                                   ₹{(test.non_membership || test.mrp || 0).toFixed(2)}
//                                 </Typography>
//                                 {test.non_membership > 0 && test.non_membership < test.mrp && (
//                                   <Typography fontSize={11} color="text.secondary" sx={{ textDecoration: "line-through" }}>
//                                     ₹{test.mrp}
//                                   </Typography>
//                                 )}

//                             </Box>
//                             <IconButton
//                               size="small"
//                               onClick={() => handleRemoveTest(test)}
//                               sx={{ color: "#DC2626" }}
//                             >
//                               <DeleteIcon fontSize="small" />
//                             </IconButton>
//                           </Box>
//                         </Box>
//                       ))}

//                       <Divider sx={{ my: 2 }} />

//                       {/* Price Summary */}
//                       <Box>
//                         <Box display="flex" justifyContent="space-between" mb={1}>
//                           <Typography fontSize={14} color="text.secondary">
//                             MRP Total:
//                           </Typography>
//                           <Typography fontSize={14}>
//                             ₹{calculateMRPTotal().toFixed(2)}
//                           </Typography>
//                         </Box>
//                         <Box display="flex" justifyContent="space-between" mb={1}>
//                           <Typography fontSize={14} color="success.main" fontWeight={600}>
//                             You Save:
//                           </Typography>
//                           <Typography fontSize={14} color="success.main" fontWeight={600}>
//                             ₹{calculateSavings().toFixed(2)}
//                           </Typography>
//                         </Box>
//                         <Box display="flex" justifyContent="space-between" mt={2}>
//                           <Typography fontSize={18} fontWeight={700}>
//                             Total Amount:
//                           </Typography>
//                           <Typography fontSize={18} fontWeight={700} color="#006D77">
//                             ₹{calculateTotal().toFixed(2)}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </CardContent>
//                   </Card>
//                 )}
//               </>
//             )}
//           </Box>

//           {/* Form Section - Only render when user data is loaded */}
//           {userLoading ? (
//             <Box display="flex" justifyContent="center" py={4}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             <CommonFieldsScreen
//               userData={user}
//               serviceData={{
//                 serviceTitle: "DIAGNOSTIC SAMPLE COLLECTION",
//                 serviceImage: DiagnosticSample,
//                 servicePrice: calculateTotal(),
//                 orderType: "diagnostic",
//                 diagnosticOrderData: {
//                   tests: selectedTests.map(test => ({
//                     test_id: test.id,
//                     test_code: test.test_code,
//                     test_name: test.test_name,
//                     mrp: test.mrp,
//                     proposed_rate: test.proposed_rate,
//                     non_membership: test.non_membership,
//                     category: test.category,
//                   })),
//                   total_amount: calculateTotal(), 
//                   mrp_total: calculateMRPTotal(),
//                   savings: calculateSavings(),
//                 }
//               }}
//             />
//           )}
//         </Paper>
//       </Container>
//       <Footer />
//     </>
//   );
// };

// export default DiagnosticDeliveryScreen;























import React, { useEffect, useState, useMemo,useRef } from "react";
import {
  Box, Typography, IconButton, Container, Avatar,
  TextField, Chip, CircularProgress, Alert,
  Divider, Button, InputAdornment, Badge, Collapse,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ScienceIcon from "@mui/icons-material/Science";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate } from "react-router-dom";
import CommonFieldsScreen from "./CommonFields";
import DiagnosticSample from "../Logos/DiagnoisticDelivery/DiagnosticSampleCollection.png";
import Footer from "../Common/Footer";
import { apiRequest } from "../../fetchSetup";
import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";
import PackageCard from "../Cards/PackageCard";


const DIAGNOSTIC_TESTS_API = process.env.REACT_APP_GET_DIAGNOSTIC_TESTS;

const BASE_URL = process.env.REACT_APP_BASE_TESTS;
const C = {
  primary: "#006D77",
  primaryDark: "#004F55",
  primaryLight: "#E0F7FA",
  bg: "#F7FAFA",
  border: "#EEEEEE",
  text: "#1a1a1a",
  muted: "#999",
  error: "#EF5350",
  success: "#2E7D32",
  successLight: "#E8F5E9",
};


// ─── CATEGORY META ────────────────────────────────────────────────────────────
const CATEGORY_META = {
  "health packages":    { color: "#EFF8EF", border: "#4CAF50", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="16" width="48" height="36" rx="4" fill="#E8F5E9" stroke="#4CAF50" stroke-width="2.5"/><path d="M26 34h12M32 28v12" stroke="#4CAF50" stroke-width="3" stroke-linecap="round"/><path d="M8 24h48" stroke="#4CAF50" stroke-width="2"/><rect x="22" y="10" width="20" height="10" rx="2" fill="#4CAF50" opacity="0.3" stroke="#4CAF50" stroke-width="2"/></svg>` },
  "anaemia":            { color: "#FFF0F0", border: "#EF5350", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="20" fill="#FFCDD2" stroke="#EF5350" stroke-width="2.5"/><path d="M32 20C36 26 42 30 36 38C32 44 26 40 24 34C22 28 28 22 32 20Z" fill="#EF5350" opacity="0.7"/><circle cx="32" cy="32" r="4" fill="#EF5350"/></svg>` },
  "diabetes":           { color: "#FFF7EE", border: "#FF9800", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="24" y="8" width="8" height="28" rx="4" fill="#FFE0B2" stroke="#FF9800" stroke-width="2.5"/><circle cx="28" cy="44" r="8" fill="#FF9800" opacity="0.2" stroke="#FF9800" stroke-width="2.5"/><path d="M40 20L52 20M52 44L40 44M52 20L52 44" stroke="#FF9800" stroke-width="2.5" stroke-linecap="round"/></svg>` },
  "heart":              { color: "#FEF0F4", border: "#E91E63", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 52C32 52 10 38 10 24C10 17 16 12 22 12C26 12 30 14 32 18C34 14 38 12 42 12C48 12 54 17 54 24C54 38 32 52 32 52Z" fill="#F48FB1" stroke="#E91E63" stroke-width="2.5"/><path d="M18 30L24 24L28 32L34 20L38 28L44 28" stroke="#E91E63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
  "liver":              { color: "#FFFBEE", border: "#FFC107", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 20C10 28 12 36 14 44C22 50 32 50 42 50C52 44 52 34 52 24C44 16 28 16 36 16C28 16 22 18 14 20Z" fill="#FFE082" stroke="#FFC107" stroke-width="2.5"/><path d="M24 30C28 26 36 28 38 34" stroke="#FFC107" stroke-width="2" stroke-linecap="round"/></svg>` },
  "lungs":              { color: "#EEF6FF", border: "#2196F3", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 12L32 40" stroke="#2196F3" stroke-width="3" stroke-linecap="round"/><path d="M32 20C22 20 12 26 12 38C12 46 18 52 26 50C30 49 32 44 32 40" fill="#BBDEFB" stroke="#2196F3" stroke-width="2.5"/><path d="M32 20C42 20 52 26 52 38C52 46 46 52 38 50C34 49 32 44 32 40" fill="#BBDEFB" stroke="#2196F3" stroke-width="2.5"/></svg>` },
  "fertility":          { color: "#F9F0FF", border: "#9C27B0", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="28" r="14" fill="#E1BEE7" stroke="#9C27B0" stroke-width="2.5"/><path d="M32 42L32 56" stroke="#9C27B0" stroke-width="2.5" stroke-linecap="round"/><path d="M26 50L32 56L38 50" stroke="#9C27B0" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="32" cy="28" r="6" fill="#9C27B0" opacity="0.4"/></svg>` },
  "kidney":             { color: "#EEF0FF", border: "#3F51B5", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 16C12 20 10 32 14 42C18 52 28 54 34 48C38 44 36 38 34 34C32 30 34 24 32 20C30 14 24 14 20 16Z" fill="#C5CAE9" stroke="#3F51B5" stroke-width="2.5"/><path d="M44 16C52 20 54 32 50 42C46 52 36 54 30 48C26 44 28 38 30 34C32 30 30 24 32 20C34 14 40 14 44 16Z" fill="#C5CAE9" stroke="#3F51B5" stroke-width="2.5"/></svg>` },
  "allergy":            { color: "#F3FAF0", border: "#8BC34A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="16" fill="#DCEDC8" stroke="#8BC34A" stroke-width="2.5"/><path d="M32 16L32 48M16 32L48 32M20 20L44 44M44 20L20 44" stroke="#8BC34A" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/><circle cx="32" cy="32" r="6" fill="#8BC34A" opacity="0.6"/></svg>` },
  "thyroid":            { color: "#E8FDFF", border: "#00BCD4", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 16C16 20 14 30 18 38C20 42 24 44 28 44L32 44L36 44C40 44 44 42 46 38C50 30 48 20 42 16C38 12 26 12 22 16Z" fill="#B2EBF2" stroke="#00BCD4" stroke-width="2.5"/><circle cx="26" cy="30" r="5" fill="#00BCD4" opacity="0.5"/><circle cx="38" cy="30" r="5" fill="#00BCD4" opacity="0.5"/></svg>` },
  "vitamins":           { color: "#FFFDE7", border: "#F9A825", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="20" y="20" width="24" height="30" rx="6" fill="#FFF176" stroke="#F9A825" stroke-width="2.5"/><rect x="24" y="12" width="16" height="12" rx="4" fill="#F9A825" opacity="0.4" stroke="#F9A825" stroke-width="2"/><path d="M26 32L30 36L38 28" stroke="#F9A825" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
  "fever":              { color: "#FFF0EE", border: "#F44336", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="28" y="8" width="8" height="34" rx="4" fill="#FFCDD2" stroke="#F44336" stroke-width="2.5"/><circle cx="32" cy="48" r="8" fill="#F44336" opacity="0.8" stroke="#F44336" stroke-width="2"/><path d="M36 16L40 12M36 24L42 22M36 32L40 34" stroke="#F44336" stroke-width="2" stroke-linecap="round" opacity="0.6"/></svg>` },
  "bone":               { color: "#F7F7F7", border: "#9E9E9E", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 14C16 14 12 18 14 22C15 24 18 24 18 26L18 38C18 40 15 40 14 42C12 46 16 50 20 50C22 50 24 48 24 46C24 44 22 42 24 40L40 40C42 42 40 44 40 46C40 48 42 50 44 50C48 50 52 46 50 42C49 40 46 40 46 38L46 26C46 24 49 24 50 22C52 18 48 14 44 14C42 14 40 16 40 18C40 20 42 22 40 24L24 24C22 22 24 20 24 18C24 16 22 14 20 14Z" fill="#E0E0E0" stroke="#9E9E9E" stroke-width="2"/></svg>` },
  "immunity":           { color: "#EFF8EF", border: "#43A047", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 8L50 16L50 34C50 44 42 52 32 56C22 52 14 44 14 34L14 16Z" fill="#C8E6C9" stroke="#43A047" stroke-width="2.5"/><path d="M24 32L29 37L40 26" stroke="#43A047" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
  "cancer":             { color: "#FEF0F4", border: "#E91E63", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="10" fill="#F48FB1" stroke="#E91E63" stroke-width="2.5"/><path d="M32 10L32 18M32 46L32 54M10 32L18 32M46 32L54 32M16 16L22 22M42 42L48 48M48 16L42 22M22 42L16 48" stroke="#E91E63" stroke-width="2.5" stroke-linecap="round" opacity="0.7"/></svg>` },
  "hormones":           { color: "#F3EEFF", border: "#673AB7", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 48C20 48 16 36 24 28C28 24 34 24 38 20C44 14 44 8 44 8" stroke="#673AB7" stroke-width="2.5" stroke-linecap="round"/><circle cx="44" cy="8" r="4" fill="#673AB7" opacity="0.6"/><path d="M44 48C44 48 48 36 40 28C36 24 30 24 26 20C20 14 20 8 20 8" stroke="#9C27B0" stroke-width="2.5" stroke-linecap="round" opacity="0.5"/><circle cx="32" cy="36" r="6" fill="#EDE7F6" stroke="#673AB7" stroke-width="2"/></svg>` },
  "prostate":           { color: "#EEF0FF", border: "#3F51B5", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="28" r="16" fill="#C5CAE9" stroke="#3F51B5" stroke-width="2.5"/><circle cx="32" cy="28" r="8" fill="#3F51B5" opacity="0.3"/><path d="M28 44L28 56M36 44L36 56" stroke="#3F51B5" stroke-width="2.5" stroke-linecap="round"/></svg>` },
  "pregnancy":          { color: "#F9F0FF", border: "#AB47BC", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="14" r="8" fill="#E1BEE7" stroke="#AB47BC" stroke-width="2.5"/><path d="M20 26C16 28 16 36 16 36C16 44 22 52 32 54C42 52 48 44 48 36C48 28 44 26 44 26C40 24 36 24 32 24C28 24 24 24 20 26Z" fill="#E1BEE7" stroke="#AB47BC" stroke-width="2.5"/><circle cx="32" cy="38" r="6" fill="#AB47BC" opacity="0.3"/></svg>` },
  "hiv":                { color: "#E8FFFD", border: "#009688", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="20" fill="#B2DFDB" stroke="#009688" stroke-width="2.5"/><path d="M22 22L42 42M42 22L22 42" stroke="#009688" stroke-width="3" stroke-linecap="round"/><circle cx="32" cy="32" r="6" fill="#009688" opacity="0.4"/></svg>` },
  "tuberculosis":       { color: "#EEF6FF", border: "#42A5F5", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 12L32 40" stroke="#42A5F5" stroke-width="3" stroke-linecap="round"/><path d="M32 18C24 18 16 24 16 34C16 42 22 48 30 48" fill="#BBDEFB" stroke="#42A5F5" stroke-width="2.5"/><path d="M32 18C40 18 48 24 48 34C48 42 42 48 34 48" fill="#BBDEFB" stroke="#42A5F5" stroke-width="2.5"/><circle cx="24" cy="34" r="4" fill="#42A5F5" opacity="0.5"/><circle cx="40" cy="34" r="4" fill="#42A5F5" opacity="0.5"/></svg>` },
  "other pathology tests": { color: "#F5FBE7", border: "#9CCC65", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="24" y="8" width="10" height="30" rx="5" fill="#DCEDC8" stroke="#9CCC65" stroke-width="2.5"/><ellipse cx="29" cy="44" rx="10" ry="6" fill="#9CCC65" opacity="0.4" stroke="#9CCC65" stroke-width="2"/><circle cx="42" cy="20" r="8" fill="#F9FBE7" stroke="#9CCC65" stroke-width="2"/><circle cx="42" cy="20" r="3" fill="#9CCC65" opacity="0.6"/></svg>` },
  "musculo skeletal disorders": { color: "#ECEFF1", border: "#607D8B", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 10L20 30C20 36 26 40 32 40C38 40 44 36 44 30L44 10" stroke="#607D8B" stroke-width="2.5" stroke-linecap="round"/><path d="M16 30C16 40 24 48 32 54C40 48 48 40 48 30" fill="#CFD8DC" stroke="#607D8B" stroke-width="2"/><circle cx="20" cy="10" r="4" fill="#607D8B" opacity="0.5"/><circle cx="44" cy="10" r="4" fill="#607D8B" opacity="0.5"/></svg>` },
  "toxicology":         { color: "#FFFBEE", border: "#FF8F00", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 10L26 26L16 42C14 46 16 52 22 52L42 52C48 52 50 46 48 42L38 26L38 10Z" fill="#FFE082" stroke="#FF8F00" stroke-width="2.5"/><path d="M24 10L40 10" stroke="#FF8F00" stroke-width="2.5" stroke-linecap="round"/><circle cx="32" cy="40" r="5" fill="#FF8F00" opacity="0.6"/></svg>` },
  "clotting disorders": { color: "#FFF0F0", border: "#EF9A9A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 10C32 10 20 22 20 34C20 44 26 52 32 52C38 52 44 44 44 34C44 22 32 10 32 10Z" fill="#FFCDD2" stroke="#E53935" stroke-width="2.5"/><path d="M26 36C28 40 36 40 38 36" stroke="#E53935" stroke-width="2" stroke-linecap="round"/></svg>` },
  "drug level monitoring": { color: "#EEF0FF", border: "#5C6BC0", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="22" y="18" width="20" height="30" rx="4" fill="#C5CAE9" stroke="#5C6BC0" stroke-width="2.5"/><rect x="26" y="10" width="12" height="10" rx="3" fill="#5C6BC0" opacity="0.4" stroke="#5C6BC0" stroke-width="2"/><path d="M28 30L36 30M28 36L34 36" stroke="#5C6BC0" stroke-width="2" stroke-linecap="round"/></svg>` },
  "heavy metals":       { color: "#ECEFF1", border: "#78909C", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="22" cy="36" r="10" fill="#CFD8DC" stroke="#546E7A" stroke-width="2.5"/><circle cx="42" cy="36" r="10" fill="#B0BEC5" stroke="#546E7A" stroke-width="2.5"/><circle cx="32" cy="26" r="10" fill="#90A4AE" stroke="#546E7A" stroke-width="2.5"/></svg>` },
  "infectious disease": { color: "#EFF8EF", border: "#66BB6A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="12" fill="#C8E6C9" stroke="#388E3C" stroke-width="2.5"/><circle cx="32" cy="32" r="5" fill="#388E3C" opacity="0.5"/><path d="M32 10L32 16M32 48L32 54M10 32L16 32M48 32L54 32M16 16L20 20M44 44L48 48M48 16L44 20M20 44L16 48" stroke="#388E3C" stroke-width="2" stroke-linecap="round"/></svg>` },
  "blood disorders":    { color: "#FFF0F0", border: "#EF5350", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 8C32 8 14 24 14 38C14 48 22 56 32 56C42 56 50 48 50 38C50 24 32 8 32 8Z" fill="#FFCDD2" stroke="#C62828" stroke-width="2.5"/><path d="M22 38C22 44 26 48 32 48" stroke="#C62828" stroke-width="2" stroke-linecap="round"/></svg>` },
  "autoimmune disorders": { color: "#F9F0FF", border: "#AB47BC", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="32" cy="28" rx="18" ry="14" fill="#E1BEE7" stroke="#7B1FA2" stroke-width="2.5"/><path d="M20 34C22 42 42 42 44 34" fill="#CE93D8" stroke="#7B1FA2" stroke-width="2"/><circle cx="24" cy="24" r="3" fill="#7B1FA2" opacity="0.5"/><circle cx="40" cy="24" r="3" fill="#7B1FA2" opacity="0.5"/></svg>` },
  "stomach":            { color: "#FFF7EE", border: "#FFA726", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 20C12 24 12 38 18 44C24 50 40 50 46 44C52 38 52 26 46 20C40 14 24 16 18 20Z" fill="#FFE0B2" stroke="#E65100" stroke-width="2.5"/><path d="M22 30C26 26 38 28 42 34" stroke="#E65100" stroke-width="2" stroke-linecap="round"/></svg>` },
  "inflammatory markers": { color: "#FFF0EE", border: "#FF7043", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 8L38 22L54 22L42 32L46 48L32 38L18 48L22 32L10 22L26 22Z" fill="#FFCCBC" stroke="#BF360C" stroke-width="2.5"/><circle cx="32" cy="28" r="6" fill="#FF7043" opacity="0.6"/></svg>` },
  "electrolytes":       { color: "#FFFDE7", border: "#FFD54F", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36 8L24 34L32 34L28 56L44 28L36 28Z" fill="#FFF176" stroke="#F57F17" stroke-width="2.5"/><circle cx="18" cy="22" r="5" fill="#FFD54F" stroke="#F57F17" stroke-width="2"/><circle cx="46" cy="44" r="5" fill="#FFD54F" stroke="#F57F17" stroke-width="2"/></svg>` },
};
// Additional meta for profile/panel types from real DB data
const EXTRA_META = {
  // surgical / major / minor surgical
  "surgical":    { color: "#E8F5E9", border: "#43A047", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 14L50 50M14 50L50 14" stroke="#43A047" stroke-width="3" stroke-linecap="round" opacity="0.3"/><path d="M20 20L44 44" stroke="#43A047" stroke-width="4" stroke-linecap="round"/><circle cx="20" cy="20" r="5" fill="#43A047" opacity="0.7"/><rect x="40" y="38" width="12" height="6" rx="2" fill="#43A047" opacity="0.5" transform="rotate(45 40 38)"/></svg>` },
  // lipid / cholesterol / cardiac
  "lipid":       { color: "#FEF0F4", border: "#E91E63", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 52C32 52 10 38 10 24C10 17 16 12 22 12C26 12 30 14 32 18C34 14 38 12 42 12C48 12 54 17 54 24C54 38 32 52 32 52Z" fill="#F48FB1" stroke="#E91E63" stroke-width="2.5"/><path d="M18 30L24 24L28 32L34 20L38 28L44 28" stroke="#E91E63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
  // torch / viral / infection / panel
  "torch":       { color: "#EFF8EF", border: "#66BB6A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="12" fill="#C8E6C9" stroke="#388E3C" stroke-width="2.5"/><circle cx="32" cy="32" r="5" fill="#388E3C" opacity="0.5"/><path d="M32 10L32 16M32 48L32 54M10 32L16 32M48 32L54 32M16 16L20 20M44 44L48 48M48 16L44 20M20 44L16 48" stroke="#388E3C" stroke-width="2" stroke-linecap="round"/></svg>` },
  // coagulation / clotting / bleeding / pt / aptt
  "coagul":      { color: "#FFF0F0", border: "#EF9A9A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 10C32 10 20 22 20 34C20 44 26 52 32 52C38 52 44 44 44 34C44 22 32 10 32 10Z" fill="#FFCDD2" stroke="#E53935" stroke-width="2.5"/><path d="M26 36C28 40 36 40 38 36" stroke="#E53935" stroke-width="2" stroke-linecap="round"/></svg>` },
  // ante natal / prenatal / obstetric / antenatal
  "natal":       { color: "#F9F0FF", border: "#AB47BC", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="14" r="8" fill="#E1BEE7" stroke="#AB47BC" stroke-width="2.5"/><path d="M20 26C16 28 16 36 16 36C16 44 22 52 32 54C42 52 48 44 48 36C48 28 44 26 44 26C40 24 36 24 32 24C28 24 24 24 20 26Z" fill="#E1BEE7" stroke="#AB47BC" stroke-width="2.5"/><circle cx="32" cy="38" r="6" fill="#AB47BC" opacity="0.3"/></svg>` },
  // viral / virus
  "viral":       { color: "#EFF8EF", border: "#66BB6A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="12" fill="#C8E6C9" stroke="#388E3C" stroke-width="2.5"/><circle cx="32" cy="32" r="5" fill="#388E3C" opacity="0.5"/><path d="M32 10L32 16M32 48L32 54M10 32L16 32M48 32L54 32M16 16L20 20M44 44L48 48M48 16L44 20M20 44L16 48" stroke="#388E3C" stroke-width="2" stroke-linecap="round"/></svg>` },
  // renal / kidney / creatinine / urea
  "renal":       { color: "#EEF0FF", border: "#3F51B5", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 16C12 20 10 32 14 42C18 52 28 54 34 48C38 44 36 38 34 34C32 30 34 24 32 20C30 14 24 14 20 16Z" fill="#C5CAE9" stroke="#3F51B5" stroke-width="2.5"/><path d="M44 16C52 20 54 32 50 42C46 52 36 54 30 48C26 44 28 38 30 34C32 30 30 24 32 20C34 14 40 14 44 16Z" fill="#C5CAE9" stroke="#3F51B5" stroke-width="2.5"/></svg>` },
  // liver / hepatic / lft / bilirubin
  "hepat":       { color: "#FFFBEE", border: "#FFC107", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 20C10 28 12 36 14 44C22 50 32 50 42 50C52 44 52 34 52 24C44 16 28 16 36 16C28 16 22 18 14 20Z" fill="#FFE082" stroke="#FFC107" stroke-width="2.5"/><path d="M24 30C28 26 36 28 38 34" stroke="#FFC107" stroke-width="2" stroke-linecap="round"/></svg>` },
  // complete blood / cbc / haemogram / blood count
  "blood":       { color: "#FFF0F0", border: "#EF5350", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 8C32 8 14 24 14 38C14 48 22 56 32 56C42 56 50 48 50 38C50 24 32 8 32 8Z" fill="#FFCDD2" stroke="#C62828" stroke-width="2.5"/><path d="M22 38C22 44 26 48 32 48" stroke="#C62828" stroke-width="2" stroke-linecap="round"/></svg>` },
  // urine / urinalysis
  "urin":        { color: "#FFFDE7", border: "#F9A825", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 10C26 10 18 28 18 40C18 50 24 56 32 56C40 56 46 50 46 40C46 28 38 10 38 10Z" fill="#FFF9C4" stroke="#F9A825" stroke-width="2.5"/><circle cx="32" cy="42" r="6" fill="#F9A825" opacity="0.4"/></svg>` },
  // hormone / endocrine / pituitary
  "hormon":      { color: "#F3EEFF", border: "#673AB7", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 48C20 48 16 36 24 28C28 24 34 24 38 20C44 14 44 8 44 8" stroke="#673AB7" stroke-width="2.5" stroke-linecap="round"/><circle cx="44" cy="8" r="4" fill="#673AB7" opacity="0.6"/><path d="M44 48C44 48 48 36 40 28C36 24 30 24 26 20C20 14 20 8 20 8" stroke="#9C27B0" stroke-width="2.5" stroke-linecap="round" opacity="0.5"/></svg>` },
  // bone / calcium / mineral / density
  "bone":        { color: "#F7F7F7", border: "#9E9E9E", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 14C16 14 12 18 14 22C15 24 18 24 18 26L18 38C18 40 15 40 14 42C12 46 16 50 20 50C22 50 24 48 24 46C24 44 22 42 24 40L40 40C42 42 40 44 40 46C40 48 42 50 44 50C48 50 52 46 50 42C49 40 46 40 46 38L46 26C46 24 49 24 50 22C52 18 48 14 44 14C42 14 40 16 40 18C40 20 42 22 40 24L24 24C22 22 24 20 24 18C24 16 22 14 20 14Z" fill="#E0E0E0" stroke="#9E9E9E" stroke-width="2"/></svg>` },
  // fever / typhoid / malaria / dengue / widal
  "fever":       { color: "#FFF0EE", border: "#F44336", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="28" y="8" width="8" height="34" rx="4" fill="#FFCDD2" stroke="#F44336" stroke-width="2.5"/><circle cx="32" cy="48" r="8" fill="#F44336" opacity="0.8" stroke="#F44336" stroke-width="2"/></svg>` },
  // stool / faecal
  "stool":       { color: "#FFF7EE", border: "#FF9800", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="32" cy="44" rx="18" ry="10" fill="#FFE0B2" stroke="#FF9800" stroke-width="2.5"/><path d="M24 44C22 36 26 28 32 26C38 28 42 36 40 44" fill="#FFCC80" stroke="#FF9800" stroke-width="2"/><circle cx="32" cy="24" r="6" fill="#FFE0B2" stroke="#FF9800" stroke-width="2"/></svg>` },
  // semen / sperm / male fertility
  "semen":       { color: "#E8FDFF", border: "#00BCD4", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="36" r="12" fill="#B2EBF2" stroke="#00BCD4" stroke-width="2.5"/><path d="M32 24L32 10M26 16L32 10L38 16" stroke="#00BCD4" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
  // culture / sensitivity / microbiology
  "cultur":      { color: "#F3FAF0", border: "#8BC34A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="18" fill="#DCEDC8" stroke="#8BC34A" stroke-width="2.5"/><circle cx="26" cy="28" r="4" fill="#8BC34A" opacity="0.5"/><circle cx="38" cy="28" r="4" fill="#8BC34A" opacity="0.5"/><circle cx="32" cy="38" r="4" fill="#8BC34A" opacity="0.5"/><circle cx="32" cy="32" r="2" fill="#8BC34A" opacity="0.8"/></svg>` },
  // iron / ferritin / thalassemia
  "iron":        { color: "#FFF0F0", border: "#EF5350", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="20" fill="#FFCDD2" stroke="#EF5350" stroke-width="2.5"/><path d="M32 20C36 26 42 30 36 38C32 44 26 40 24 34C22 28 28 22 32 20Z" fill="#EF5350" opacity="0.7"/></svg>` },
  // electrolyte / sodium / potassium
  "electro":     { color: "#FFFDE7", border: "#FFD54F", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36 8L24 34L32 34L28 56L44 28L36 28Z" fill="#FFF176" stroke="#F57F17" stroke-width="2.5"/></svg>` },
  // allergy / skin prick
  "allerg":      { color: "#F3FAF0", border: "#8BC34A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="16" fill="#DCEDC8" stroke="#8BC34A" stroke-width="2.5"/><path d="M32 16L32 48M16 32L48 32M20 20L44 44M44 20L20 44" stroke="#8BC34A" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/><circle cx="32" cy="32" r="6" fill="#8BC34A" opacity="0.6"/></svg>` },
  // comprehensive / complete / full body
  "compreh":     { color: "#EFF8EF", border: "#4CAF50", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="16" width="48" height="36" rx="4" fill="#E8F5E9" stroke="#4CAF50" stroke-width="2.5"/><path d="M26 34h12M32 28v12" stroke="#4CAF50" stroke-width="3" stroke-linecap="round"/><path d="M8 24h48" stroke="#4CAF50" stroke-width="2"/><rect x="22" y="10" width="20" height="10" rx="2" fill="#4CAF50" opacity="0.3" stroke="#4CAF50" stroke-width="2"/></svg>` },
};

const DEFAULT_META = { color: "#F5F5F5", border: "#BDBDBD", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="14" width="44" height="38" rx="4" fill="#E0E0E0" stroke="#9E9E9E" stroke-width="2.5"/><rect x="10" y="22" width="44" height="2" fill="#9E9E9E" opacity="0.3"/><circle cx="24" cy="36" r="6" fill="#9E9E9E" opacity="0.3"/><path d="M34 32h12M34 38h8" stroke="#9E9E9E" stroke-width="2" stroke-linecap="round" opacity="0.5"/></svg>` };

// Keyword rules: order matters — first match wins
const KEYWORD_RULES = [
  // Exact-ish common names
  ["thyroid",     CATEGORY_META["thyroid"]],
  ["diabetes",    CATEGORY_META["diabetes"]],
  ["diabetic",    CATEGORY_META["diabetes"]],
  ["heart",       CATEGORY_META["heart"]],
  ["cardiac",     CATEGORY_META["heart"]],
  ["lipid",       EXTRA_META["lipid"]],
  ["cholesterol", EXTRA_META["lipid"]],
  ["liver",       CATEGORY_META["liver"]],
  ["hepat",       EXTRA_META["hepat"]],
  ["lft",         CATEGORY_META["liver"]],
  ["kidney",      CATEGORY_META["kidney"]],
  ["renal",       EXTRA_META["renal"]],
  ["lung",        CATEGORY_META["lungs"]],
  ["pulmo",       CATEGORY_META["lungs"]],
  ["cancer",      CATEGORY_META["cancer"]],
  ["tumour",      CATEGORY_META["cancer"]],
  ["tumor",       CATEGORY_META["cancer"]],
  ["oncol",       CATEGORY_META["cancer"]],
  ["marker",      CATEGORY_META["cancer"]],
  ["anaemia",     CATEGORY_META["anaemia"]],
  ["anemia",      CATEGORY_META["anaemia"]],
  ["haemoglob",   CATEGORY_META["anaemia"]],
  ["hemoglob",    CATEGORY_META["anaemia"]],
  ["iron",        EXTRA_META["iron"]],
  ["ferrit",      EXTRA_META["iron"]],
  ["thalass",     EXTRA_META["iron"]],
  ["hormone",     EXTRA_META["hormon"]],
  ["hormonal",    EXTRA_META["hormon"]],
  ["endocrin",    EXTRA_META["hormon"]],
  ["fertility",   CATEGORY_META["fertility"]],
  ["infertil",    CATEGORY_META["fertility"]],
  ["semen",       EXTRA_META["semen"]],
  ["sperm",       EXTRA_META["semen"]],
  ["prostate",    CATEGORY_META["prostate"]],
  ["psa",         CATEGORY_META["prostate"]],
  ["pregnancy",   CATEGORY_META["pregnancy"]],
  ["prenatal",    CATEGORY_META["pregnancy"]],
  ["natal",       EXTRA_META["natal"]],
  ["obstetric",   EXTRA_META["natal"]],
  ["torch",       EXTRA_META["torch"]],
  ["viral",       EXTRA_META["viral"]],
  ["virus",       EXTRA_META["viral"]],
  ["hiv",         CATEGORY_META["hiv"]],
  ["aids",        CATEGORY_META["hiv"]],
  ["tuberculosis",CATEGORY_META["tuberculosis"]],
  ["tb ",         CATEGORY_META["tuberculosis"]],
  ["typhoid",     EXTRA_META["fever"]],
  ["malaria",     EXTRA_META["fever"]],
  ["dengue",      EXTRA_META["fever"]],
  ["fever",       EXTRA_META["fever"]],
  ["widal",       EXTRA_META["fever"]],
  ["allerg",      EXTRA_META["allerg"]],
  ["bone",        EXTRA_META["bone"]],
  ["calcium",     EXTRA_META["bone"]],
  ["mineral",     EXTRA_META["bone"]],
  ["vitamin",     CATEGORY_META["vitamins"]],
  ["vitamin",     CATEGORY_META["vitamins"]],
  ["electrolyte", EXTRA_META["electro"]],
  ["sodium",      EXTRA_META["electro"]],
  ["potassium",   EXTRA_META["electro"]],
  ["coagul",      EXTRA_META["coagul"]],
  ["clott",       EXTRA_META["coagul"]],
  ["platelet",    EXTRA_META["coagul"]],
  ["blood",       EXTRA_META["blood"]],
  ["cbc",         EXTRA_META["blood"]],
  ["haemogram",   EXTRA_META["blood"]],
  ["hemogram",    EXTRA_META["blood"]],
  ["urin",        EXTRA_META["urin"]],
  ["stool",       EXTRA_META["stool"]],
  ["faecal",      EXTRA_META["stool"]],
  ["fecal",       EXTRA_META["stool"]],
  ["cultur",      EXTRA_META["cultur"]],
  ["sensitiv",    EXTRA_META["cultur"]],
  ["microbi",     EXTRA_META["cultur"]],
  ["surgical",    EXTRA_META["surgical"]],
  ["surgery",     EXTRA_META["surgical"]],
  ["pre-op",      EXTRA_META["surgical"]],
  ["preop",       EXTRA_META["surgical"]],
  ["immunolog",   CATEGORY_META["immunity"]],
  ["autoimmune",  CATEGORY_META["autoimmune disorders"]],
  ["inflamm",     CATEGORY_META["inflammatory markers"]],
  ["stomach",     CATEGORY_META["stomach"]],
  ["gastro",      CATEGORY_META["stomach"]],
  ["toxicol",     CATEGORY_META["toxicology"]],
  ["drug level",  CATEGORY_META["drug level monitoring"]],
  ["heavy metal", CATEGORY_META["heavy metals"]],
  ["compreh",     EXTRA_META["compreh"]],
  ["complete",    EXTRA_META["compreh"]],
  ["full body",   EXTRA_META["compreh"]],
  ["senior",      EXTRA_META["compreh"]],
  ["wellness",    EXTRA_META["compreh"]],
  ["package",     EXTRA_META["compreh"]],
  ["profile",     EXTRA_META["compreh"]],
  ["panel",       EXTRA_META["compreh"]],
  ["screening",   EXTRA_META["compreh"]],
];

function getCategoryMeta(cat) {
  const key = (cat || "").toLowerCase().trim();
  // 1. Try exact match first
  if (CATEGORY_META[key]) return CATEGORY_META[key];
  // 2. Try keyword rules
  for (const [keyword, meta] of KEYWORD_RULES) {
    if (key.includes(keyword)) return meta;
  }
  // 3. Fallback
  return DEFAULT_META;
}
function CategorySVG({ meta, size = 56 }) {
  return (
    <img
      src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(meta.icon)}`}
      alt=""
      style={{ width: size, height: size, objectFit: "contain", display: "block" }}
    />
  );
}

// ─── STEP BAR ─────────────────────────────────────────────────────────────────
function StepBar({ step }) {
  const steps = ["Choose Tests", "Review Cart", "Book Appointment"];
  return (
    <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
      {steps.map((label, i) => {
        const num = i + 1;
        const done = step > num;
        const active = step === num;
        return (
          <React.Fragment key={num}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
              <Box sx={{
                width: 30, height: 30, borderRadius: "50%",
                bgcolor: done || active ? "#006D77" : "#E0E0E0",
                color: done || active ? "#fff" : "#999",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 12, fontWeight: 700,
                border: active ? "3px solid #B2DFDB" : "none",
                transition: "all 0.3s",
              }}>
                {done ? <CheckCircleIcon sx={{ fontSize: 16 }} /> : num}
              </Box>
              <Typography sx={{ fontSize: 10, mt: 0.5, fontWeight: active ? 700 : 400, color: active || done ? "#006D77" : "#bbb", whiteSpace: "nowrap" }}>
                {label}
              </Typography>
            </Box>
            {i < steps.length - 1 && (
              <Box sx={{ height: 2, flex: 1, bgcolor: step > num ? "#006D77" : "#E0E0E0", mb: 2.5, transition: "all 0.4s" }} />
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
}

// ─── CATEGORY CARD (MedPlus style) ───────────────────────────────────────────
function CategoryCard({ name, count, isActive, onClick }) {
  const meta = getCategoryMeta(name);
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "flex-start",
        p: { xs: 1.5, sm: 2 }, pt: { xs: 2, sm: 2.5 }, pb: { xs: 1.5, sm: 2 },
        borderRadius: 3, cursor: "pointer",
        bgcolor: isActive ? meta.color : "#fff",
        border: isActive ? `2px solid ${meta.border}` : "1.5px solid #EEEEEE",
        boxShadow: isActive ? `0 0 0 3px ${meta.border}22` : "0 1px 4px rgba(0,0,0,0.06)",
        transition: "all 0.18s ease",
        minHeight: { xs: 90, sm: 110 },
        "&:hover": {
          borderColor: meta.border,
          boxShadow: `0 4px 16px ${meta.border}28`,
          transform: "translateY(-2px)",
          bgcolor: meta.color,
        },
      }}
    >
      <Box sx={{
        width: { xs: 52, sm: 64 }, height: { xs: 52, sm: 64 },
        borderRadius: 2.5, bgcolor: meta.color,
        display: "flex", alignItems: "center", justifyContent: "center",
        mb: 1, border: `1px solid ${meta.border}33`,
      }}>
        <CategorySVG meta={meta} size={isActive ? 44 : 40} />
      </Box>
      <Typography sx={{
        fontSize: { xs: 10, sm: 11 }, fontWeight: isActive ? 700 : 500,
        color: isActive ? meta.border : "#444",
        textAlign: "center", lineHeight: 1.3,
        display: "-webkit-box", WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical", overflow: "hidden",
        wordBreak: "break-word",
      }}>
        {name}
      </Typography>
    </Box>
  );
}

// ─── TEST CARD (MedPlus style exactly) ───────────────────────────────────────
function TestCard({ test, isInCart, onAdd, onRemove }) {
  const [showInfo, setShowInfo] = useState(false);
  const price = test.non_membership || test.proposed_rate || test.mrp || 0;
  const mrp = test.mrp || 0;
  const hasDiscount = mrp > 0 && price < mrp;
  const meta = getCategoryMeta(test.category);

  return (
    <Box sx={{
      borderRadius: 2.5, bgcolor: "#fff",
      border: isInCart ? "1.5px solid #006D77" : "1px solid #EEEEEE",
      boxShadow: isInCart ? "0 2px 16px rgba(0,109,119,0.12)" : "0 1px 6px rgba(0,0,0,0.06)",
      overflow: "hidden",
      transition: "all 0.2s",
      display: "flex", flexDirection: "column",
      "&:hover": { boxShadow: "0 4px 20px rgba(0,0,0,0.1)", transform: "translateY(-1px)" },
    }}>
      {/* Card body */}
      <Box sx={{ p: 2, flex: 1 }}>
        {/* Test name + info icon */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
          <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: "#1a1a1a", lineHeight: 1.4, flex: 1, pr: 1 }}>
            {test.test_name}
          </Typography>
          <IconButton
            size="small"
            onClick={() => setShowInfo((v) => !v)}
            sx={{
              p: 0.3, flexShrink: 0, mt: 0.1,
              color: showInfo ? "#006D77" : "#BDBDBD",
              "&:hover": { color: "#006D77", bgcolor: "#E0F7FA" },
              transition: "color 0.2s",
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: 28 ,color: "#006D77",}} />
          </IconButton>
        </Box>

        {/* ── About This Test expandable panel ── */}
        <Collapse in={showInfo} timeout={250}>
          <Box sx={{
            mb: 2, p: 1.5, borderRadius: 2,
            bgcolor: meta.color,
            border: `1px solid ${meta.border}44`,
            position: "relative",
          }}>
            {/* Close button */}
            <IconButton
              size="small"
              onClick={() => setShowInfo(false)}
              sx={{
                position: "absolute", top: 6, right: 6,
                p: 0.2, color: "#999",
                "&:hover": { color: "#333", bgcolor: "rgba(0,0,0,0.06)" },
              }}
            >
              <CloseIcon sx={{ fontSize: 13 }} />
            </IconButton>

            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, mb: 1 }}>
              <InfoOutlinedIcon sx={{ fontSize: 13, color: meta.border }} />
              <Typography sx={{ fontSize: 11, fontWeight: 700, color: meta.border }}>
                About This Test
              </Typography>
            </Box>

            {test.description ? (
              <Typography sx={{ fontSize: 11.5, color: "#444", lineHeight: 1.6, pr: 2 }}>
                {test.description}
              </Typography>
            ) : (
              <Typography sx={{ fontSize: 11.5, color: "#888", lineHeight: 1.6, fontStyle: "italic" }}>
                No description available for this test.
              </Typography>
            )}

            {/* Extra info chips if available */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: test.description ? 1.5 : 1 }}>
              {test.parameters && (
                <Chip
                  label={`${test.parameters} Parameters`}
                  size="small"
                  sx={{ height: 20, fontSize: 9.5, fontWeight: 600, bgcolor: "#fff", color: meta.border, border: `1px solid ${meta.border}66`, "& .MuiChip-label": { px: 1 } }}
                />
              )}
              {test.sample_type && (
                <Chip
                  label={`Sample: ${test.sample_type}`}
                  size="small"
                  sx={{ height: 20, fontSize: 9.5, fontWeight: 600, bgcolor: "#fff", color: "#666", border: "1px solid #DDD", "& .MuiChip-label": { px: 1 } }}
                />
              )}
              {test.test_code && (
                <Chip
                  label={`Code: ${test.test_code}`}
                  size="small"
                  sx={{ height: 20, fontSize: 9.5, bgcolor: "#fff", color: "#999", border: "1px solid #EEE", "& .MuiChip-label": { px: 1 } }}
                />
              )}
            </Box>
          </Box>
        </Collapse>

        {/* MA Price row */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
          <Box>
            <Typography sx={{ fontSize: 10, color: "#999", mb: 0.2 }}>Our Price</Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#1a1a1a" }}>
              ₹{price.toFixed(2)}
            </Typography>
          </Box>
          {isInCart ? (
            <Button
              size="small"
              variant="outlined"
              onClick={() => onRemove(test)}
              sx={{
                borderColor: "#006D77", color: "#006D77",
                textTransform: "none", fontSize: 11, fontWeight: 600,
                borderRadius: 5, px: 1.5, py: 0.4, minWidth: "auto",
                "&:hover": { bgcolor: "#E0F7FA" },
              }}
            >
              ✓ Added
            </Button>
          ) : (
            <Button
              size="small"
              variant="outlined"
              sx={{
                borderColor: "#BDBDBD", color: "#555",
                textTransform: "none", fontSize: 10, fontWeight: 500,
                borderRadius: 5, px: 1.5, py: 0.4,
              }}
            >
              Get Ayuja<br />
              <span style={{ fontSize: 9, color: "#006D77", fontWeight: 700 }}>Advantage</span>
            </Button>
          )}
        </Box>

        {/* MRP row */}
        <Box sx={{ mb: 1.5 }}>
          <Typography sx={{ fontSize: 10, color: "#999", mb: 0.2 }}>MRP</Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#1a1a1a",textDecoration: "line-through" }}>
              ₹{mrp.toFixed(2)}
            </Typography>
            {hasDiscount && (
              <Chip
                label={`${Math.round(((mrp - price) / mrp) * 100)}% off`}
                size="small"
                sx={{ height: 18, fontSize: 9, fontWeight: 700, bgcolor: "#E8F5E9", color: "#2E7D32", "& .MuiChip-label": { px: 1 } }}
              />
            )}
          </Box>
        </Box>
      </Box>

      {/* Add to Cart button */}
      <Box sx={{ px: 2, pb: 1.5 }}>
        <Button
          fullWidth
          variant="contained"
          onClick={isInCart ? () => onRemove(test) : () => onAdd(test)}
          sx={{
            borderRadius: 5, py: 0.9,
            textTransform: "none", fontWeight: 700, fontSize: 13,
            background: isInCart
              ? "linear-gradient(90deg, #004F55 0%, #006D77 100%)"
              : "linear-gradient(90deg, #006D77 0%, #00838F 100%)",
            boxShadow: "0 3px 10px rgba(0,109,119,0.3)",
            "&:hover": { background: "linear-gradient(90deg, #004048 0%, #005F6B 100%)" },
          }}
        >
          {isInCart ? "✓ Remove from Cart" : "Add To Cart"}
        </Button>
      </Box>

      {/* Sample collection footer */}
      <Box sx={{
        px: 2, py: 1.2, bgcolor: "#FAFAFA",
        borderTop: "1px solid #F0F0F0",
      }}>
        <Typography sx={{ fontSize: 9.5, color: "#999", mb: 0.2 }}>Sample Collection Option</Typography>
        <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#555" }}>
          {test.sample_type ? `${test.sample_type} · Home collection` : "Home collection & Lab Walk-in"}
        </Typography>
      </Box>
    </Box>
  );
}

// ─── CART REVIEW ──────────────────────────────────────────────────────────────
function CartReview({ cart, onRemove, onContinue }) {
  const total = cart.reduce((s, t) => s + (t.non_membership || t.proposed_rate || t.mrp || 0), 0);
  const mrpTotal = cart.reduce((s, t) => s + (t.mrp || 0), 0);
  const savings = mrpTotal - total;

  return (
    <Box>
      <Typography fontWeight={800} fontSize={20} color="#1a1a1a" mb={0.5}>Your Cart</Typography>
      <Typography fontSize={12} color="#999" mb={3}>{cart.length} test{cart.length > 1 ? "s" : ""} selected</Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 3 }}>
        {cart.map((test) => {
          const meta = getCategoryMeta(test.category);
          const price = test.non_membership || test.proposed_rate || test.mrp || 0;
          return (
            <Box key={test.id} sx={{
              display: "flex", alignItems: "center", gap: 2,
              p: 2, borderRadius: 2.5, bgcolor: "#fff",
              border: "1px solid #EEEEEE",
              boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
            }}>
              <Box sx={{
                width: 44, height: 44, borderRadius: 2, flexShrink: 0,
                bgcolor: meta.color, display: "flex", alignItems: "center", justifyContent: "center",
                border: `1px solid ${meta.border}44`,
              }}>
                <CategorySVG meta={meta} size={30} />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a", lineHeight: 1.3 }}>
                  {test.test_name}
                </Typography>
                <Typography sx={{ fontSize: 10.5, color: "#999", mt: 0.3 }}>{test.category}</Typography>
              </Box>
              <Box sx={{ textAlign: "right", flexShrink: 0 }}>
                <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#1a1a1a" }}>₹{price.toFixed(2)}</Typography>
                {test.mrp && price < test.mrp && (
                  <Typography sx={{ fontSize: 10, color: "#bbb", textDecoration: "line-through" }}>₹{test.mrp}</Typography>
                )}
              </Box>
              <IconButton size="small" onClick={() => onRemove(test)} sx={{ color: "#EF5350", flexShrink: 0 }}>
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>

            </Box>
          );
        })}
      </Box>

      {/* Price Summary */}
      <Box sx={{ borderRadius: 3, border: "1px solid #EEEEEE", overflow: "hidden", mb: 3 }}>
        <Box sx={{ bgcolor: "#006D77", px: 2.5, py: 1.5 }}>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>Price Summary</Typography>
        </Box>
        <Box sx={{ bgcolor: "#FAFFFE", p: 2.5 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography fontSize={13} color="#666">Total MRP</Typography>
            <Typography fontSize={13} fontWeight={600}>₹{mrpTotal.toFixed(2)}</Typography>
          </Box>
          {savings > 0 && (
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography fontSize={13} color="#2E7D32" fontWeight={600} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <LocalOfferIcon sx={{ fontSize: 14 }} /> Total Savings
              </Typography>
              <Typography fontSize={13} color="#2E7D32" fontWeight={700}>-₹{savings.toFixed(2)}</Typography>
            </Box>
          )}
          <Divider sx={{ my: 1.5 }} />
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography fontSize={15} fontWeight={800}>Total Payable</Typography>
            <Typography fontSize={15} fontWeight={800} color="#006D77">₹{total.toFixed(2)}</Typography>
          </Box>
        </Box>
      </Box>

      <Button
        fullWidth variant="contained"
        onClick={onContinue}
        disabled={!cart || cart.length === 0}
        endIcon={<KeyboardArrowRightIcon />}
        sx={{
          background: "linear-gradient(90deg, #006D77 0%, #00838F 100%)",
          borderRadius: 3, py: 1.8,
          fontSize: 15, fontWeight: 800, textTransform: "none",
          boxShadow: "0 6px 20px rgba(0,109,119,0.4)",
          "&:hover": { background: "linear-gradient(90deg, #004F55 0%, #006064 100%)" },
        }}
      >
        Continue to Book Appointment
      </Button>
    </Box>
  );
}

// ─── FLOATING CART BAR ────────────────────────────────────────────────────────
function CartBar({ cart, onViewCart }) {
  if (cart.length === 0) return null;
  const total = cart.reduce((s, t) => s + (t.non_membership || t.proposed_rate || t.mrp || 0), 0);
  return (
    <Box sx={{
      position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000,
      background: "linear-gradient(90deg, #006D77 0%, #004F55 100%)",
      color: "#fff", px: { xs: 2, md: 4 }, py: 1.5,
      display: "flex", alignItems: "center", justifyContent: "space-between",
      boxShadow: "0 -4px 24px rgba(0,109,119,0.3)",
    }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Badge badgeContent={cart.length} color="error">
          <ShoppingCartOutlinedIcon />
        </Badge>
        <Box>
          <Typography sx={{ fontSize: 11, opacity: 0.8 }}>
            {cart.length} test{cart.length > 1 ? "s" : ""} in cart
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 800 }}>₹{total.toFixed(2)}</Typography>
        </Box>
      </Box>
      <Button
        variant="contained"
        onClick={onViewCart}
        endIcon={<KeyboardArrowRightIcon />}
        sx={{
          bgcolor: "#fff", color: "#006D77",
          fontWeight: 800, fontSize: 13, textTransform: "none",
          borderRadius: 2.5, px: 3, py: 1,
          "&:hover": { bgcolor: "#E0F7FA" },
        }}
      >
        View Cart
      </Button>
    </Box>
  );
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────
const DiagnosticDeliveryScreen = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState(null);
  const [search, setSearch] = useState("");
  const [step, setStep] = useState(1);

  const [categories, setCategories] = useState([]);
  const [tests, setTests] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalTests, setTotalTests] = useState(0);
  const [testsLoading, setTestsLoading] = useState(false);
  const [catLoading, setCatLoading] = useState(true);
  const LIMIT = 20;
  const [packages, setPackages] = useState([]);
  const [showAllPackagesModal, setShowAllPackagesModal] = useState(false);
  const API = process.env.REACT_APP_API_BASE_URL;


  useEffect(() => {
    // Fetch user
    const fetchUser = async () => {
      setUserLoading(true);
      const stored = sessionStorage.getItem("user");
      if (stored) setUser(JSON.parse(stored));
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (userId && token) {
        try {
          const ud = await fetchUserFromRedis(userId, token);
          if (ud) { setUser(ud); sessionStorage.setItem("user", JSON.stringify(ud)); }
        } catch (e) { console.error(e); }
      }
      setUserLoading(false);
    };
    fetchUser();
  
    // Fetch categories
    fetchCategories();
  }, []);


  // ✅ CORRECT FIX — replace both useEffects with this
  const pageRef = useRef(1);
  const categoryRef = useRef(activeCategory);
  const resetPage = () => { pageRef.current = 1; setPage(1); };

// useEffect(() => { searchRef.current = search; }, [search]);
useEffect(() => { categoryRef.current = activeCategory; }, [activeCategory]);

// ✅ Search / category change — debounced, resets page to 1
useEffect(() => {
  const timer = setTimeout(() => {
    pageRef.current = 1;        // update ref immediately
    setPage(1);                 // update display (won't trigger fetchTests again)
    fetchTests(1, activeCategory, search);
  }, search ? 400 : 0);
  return () => clearTimeout(timer);
}, [search, activeCategory]);   // ← only these two

// ✅ Pagination clicks only
useEffect(() => {
  fetchTests(page, activeCategory, search);
}, [page]);                     // ← only page


// Fetch categories once on mount
const fetchCategories = async () => {
  setCatLoading(true);
  try {
    const res = await apiRequest(`${BASE_URL}/diagnostic-categories`);
    const data = await res.json();
        const updatedCategories = [
      { name: "Packages" },
      ...data.categories
    ];
     setCategories(updatedCategories);
  } catch { setError("Failed to load categories."); }
  finally { setCatLoading(false); }
};

useEffect(()=>{
    getAvailablePackages()
  },[activeCategory])

// Fetch tests whenever page/category/search changes
const fetchTests = async (pageNum, cat, searchVal) => {
  setTestsLoading(true);
  try {
    const params = new URLSearchParams({
      page: pageNum,
      limit: LIMIT,
      ...(searchVal && { search: searchVal }),
      ...(cat && { category: cat }),
    });
    const res = await apiRequest(`${BASE_URL}/diagnostic-tests?${params}`);
    const data = await res.json();
    setTests(data.tests);
    setTotalPages(data.total_pages);
    setTotalTests(data.total);
  } catch { setError("Failed to load tests."); }
  finally { setTestsLoading(false); }
};
const getAvailablePackages=async()=>{
  setLoading(true);
      try {
        const res  = await fetch(`${API}/health-camp/packages`);
        const data = await res.json();
        if (data.success) setPackages(data.packages || []);
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    }

  const getKey = (t) => t.id || t.test_name;
  const cartIds = useMemo(() => new Set(cart.map((t) => t.id)), [cart]);
  const addToCart = (test) => setCart((p) => [...p, test]);
  const removeFromCart = (test) => setCart((p) => p.filter((t) => t.id !== test.id));
  const calcTotal = () => cart.reduce((s, t) => s + (t.non_membership || t.proposed_rate || t.mrp || 0), 0);
  const calcMRP = () => cart.reduce((s, t) => s + (t.mrp || 0), 0);
  const calcSavings = () => calcMRP() - calcTotal();

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
    else { sessionStorage.removeItem("commonFormData"); navigate("/services"); }
  };

  return (
    <>
      <Box sx={{ minHeight: "100vh", bgcolor: "#F7FAFA", pb: cart.length > 0 && step === 1 ? 9 : 0 }}>

        {/* ── TOP NAV ── */}
        <Box sx={{
          bgcolor: "#fff", borderBottom: "1px solid #EEEEEE",
          px: { xs: 2, md: 4 }, py: 1.5,
          display: "flex", alignItems: "center", gap: 2,
          position: "sticky", top: 0, zIndex: 10,
          boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
        }}>
          <IconButton onClick={handleBack} size="small" sx={{ bgcolor: "#F5F5F5" }}>
            <ArrowBackIosNewIcon sx={{ fontSize: 14 }} />
          </IconButton>
          <Avatar src={DiagnosticSample} sx={{ width: 36, height: 36, borderRadius: 1.5 }} />
          <Box sx={{ flex: 1 }}>
            <Typography fontWeight={700} fontSize={14} color="#1a1a1a">Diagnostic Sample Collection</Typography>
            <Typography fontSize={10} color="#999">Home collection · Results in 24–48 hrs</Typography>
          </Box>
          {step === 1 && cart.length > 0 && (
            <Badge badgeContent={cart.length} color="error">
              <IconButton size="small" onClick={() => setStep(2)} sx={{ bgcolor: "#E0F7FA" }}>
                <ShoppingCartOutlinedIcon sx={{ color: "#006D77", fontSize: 20 }} />
              </IconButton>
            </Badge>
          )}
        </Box>

        <Container maxWidth="lg" sx={{ pt: 3, pb: 4 }}>

          {/* Step bar */}
          <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: 2.5, mb: 3, border: "1px solid #EEEEEE" }}>
            <StepBar step={step} />
          </Box>

          {/* ── STEP 1: BROWSE ── */}
          {step === 1 && (
            <>
              {error && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{error}</Alert>}
              {/* Search */}
              <TextField
                    fullWidth
                    placeholder="Search diagnostic tests by name or code..."
                    value={search}
                    onChange={(e) => { setSearch(e.target.value); if (e.target.value) setActiveCategory(null); }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: "#006D77" }} />
                        </InputAdornment>
                      ),
                      endAdornment: search ? (
                        <InputAdornment position="end">
                          <IconButton size="small" onClick={() => setSearch("")}>
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                    }}
                    sx={{
                      mb: 3,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 3, bgcolor: "#fff",
                        "& fieldset": { borderColor: "#E0E0E0" },
                        "&:hover fieldset": { borderColor: "#006D77" },
                        "&.Mui-focused fieldset": { borderColor: "#006D77", borderWidth: 2 },
                      },
                    }}
                  />
              {(testsLoading || catLoading) ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
                  <CircularProgress sx={{ color: "#006D77" }} />
                </Box>
              ) : (
                <>
                  

                  {/* Category grid — hidden during search */}
                  {!search && (
                    <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: { xs: 2, md: 3 }, mb: 3, border: "1px solid #EEEEEE" }}>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                        <Typography fontWeight={700} fontSize={15} color="#1a1a1a">
                          Condition Based Diagnostic Tests
                        </Typography>
                        {activeCategory && (
                          <Chip
                            label="Clear filter"
                            size="small"
                            onClick={() => setActiveCategory(null)}
                            onDelete={() => setActiveCategory(null)}
                            deleteIcon={<CloseIcon sx={{ fontSize: "13px !important" }} />}
                            sx={{ bgcolor: "#E0F7FA", color: "#006D77", border: "1px solid #B2DFDB", fontSize: 11, "& .MuiChip-deleteIcon": { color: "#006D77" } }}
                          />
                        )}
                      </Box>
                      <Box sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "repeat(3, 1fr)", sm: "repeat(5, 1fr)", md: "repeat(7, 1fr)", lg: "repeat(9, 1fr)" },
                        gap: { xs: 1, sm: 1.5 },
                      }}>
                        {categories.map(({ name, count }) => (
                          <CategoryCard
                            key={name}
                            name={name}
                            count={count}
                            isActive={activeCategory === name}
                            onClick={() => {
                              setActiveCategory(activeCategory === name ? null : name);
                              setPage(1);
                            }}
                          />
                        ))}
                      </Box>
                    </Box>
                  )}

                  {/* Tests section */}
                  <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: { xs: 2, md: 3 }, border: "1px solid #EEEEEE" }}>
                    {/* Header */}
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2.5 }}>
                      <Box>
                        <Typography fontWeight={800} fontSize={22} color="#1a1a1a">
                          {activeCategory || (search ? `Results for "${search}"` : "All Tests")}
                        </Typography>
                        
                      </Box>
                     {activeCategory !== "Packages" && (<Typography fontSize={12} color="#999" fontWeight={500}>
                        {totalTests} Items
                      </Typography>)}
                    </Box>
                     
  {
    activeCategory === "Packages" ? (
                      <>
                        {packages.length === 0 ? (
                          <Box textAlign="center" py={6}>
                            <Typography sx={{ fontSize: 48 }}>📦</Typography>
                            <Typography sx={{ fontSize: 15, fontWeight: 600, color: "#bbb", mt: 1.5 }}>
                              No packages available
                            </Typography>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: {
                                xs: "1fr",
                                sm: "repeat(2,1fr)",
                                md: "repeat(3,1fr)",
                                lg: "repeat(4,1fr)",
                              },
                              gap: 1.5,
                            }}
                          >
                            {packages.map((pkg) => (
                              <Box key={pkg.id} sx={{ minWidth: 300, flexShrink: 0, }} > <PackageCard key={pkg.id} pkg={pkg} onBook={addToCart} onRemove={removeFromCart} isInCart={cartIds.has(getKey(pkg))}/> </Box>
                            ))}
                          </Box>
                        )}
                      </>
                    ) :
                     testsLoading ? (
                                        <Box display="flex" justifyContent="center" py={6}>
                                          <CircularProgress sx={{ color: C.primary }} />
                                        </Box>
                                      ) : 
                      tests.length === 0 ? (
                      <Box sx={{ textAlign: "center", py: 8 }}>
                        <ScienceIcon sx={{ fontSize: 56, color: "#E0E0E0", mb: 2 }} />
                        <Typography color="#bbb" fontSize={15} fontWeight={600}>No tests found</Typography>
                        <Typography color="#ccc" fontSize={12} mt={0.5}>Try a different search or category</Typography>
                      </Box>
                    ) : (
                      <Box sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(4, 1fr)" },
                        gap: 2,
                      }}>
                        {tests.map((test) => (
                          <TestCard
                            key={test.id}
                            test={test}
                            isInCart={cartIds.has(test.id)}
                            onAdd={addToCart}
                            onRemove={removeFromCart}
                          />
                        ))}
                      </Box>
                    )}
                  </Box>
                </>
              )}


            {/* Pagination */}
            {totalPages > 1 && (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1, mt: 3 }}>
                <Button
                  disabled={page === 1}
                  onClick={() => setPage(p => p - 1)}
                  variant="outlined"
                  size="small"
                  sx={{ borderRadius: 2, borderColor: "#006D77", color: "#006D77" }}
                >
                  Previous
                </Button>
                
                {/* Page number chips */}
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  const pageNum = Math.max(1, Math.min(page - 2, totalPages - 4)) + i;
                  return (
                    <Chip
                      key={pageNum}
                      label={pageNum}
                      onClick={() => setPage(pageNum)}
                      sx={{
                        cursor: "pointer",
                        bgcolor: page === pageNum ? "#006D77" : "#fff",
                        color: page === pageNum ? "#fff" : "#555",
                        border: "1px solid #E0E0E0",
                        fontWeight: page === pageNum ? 700 : 400,
                      }}
                    />
                  );
                })}
                
                <Button
                  disabled={page === totalPages}
                  onClick={() => setPage(p => p + 1)}
                  variant="outlined"
                  size="small"
                  sx={{ borderRadius: 2, borderColor: "#006D77", color: "#006D77" }}
                >
                  Next
                </Button>
                
                <Typography fontSize={11} color="#999" ml={1}>
                  Page {page} of {totalPages} · {totalTests} tests
                </Typography>
              </Box>
            )}
            </>
          )}

          {/* ── STEP 2: CART ── */}
          {step === 2 && (
            <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: { xs: 2, md: 3 }, border: "1px solid #EEEEEE" }}>
              <CartReview cart={cart} onRemove={removeFromCart} onContinue={() => setStep(3)} />
            </Box>
          )}

          {/* ── STEP 3: BOOKING ── */}
          {step === 3 && (
            <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: { xs: 2, md: 3 }, border: "1px solid #EEEEEE" }}>
              {/* Cart summary strip */}
              <Box sx={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                p: 2, mb: 3, borderRadius: 2.5,
                bgcolor: "#F0FFFE", border: "1.5px solid #B2DFDB",
              }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Box sx={{ bgcolor: "#006D77", borderRadius: 1.5, p: 0.8 }}>
                    <ScienceIcon sx={{ color: "#fff", fontSize: 18 }} />
                  </Box>
                  <Box>
                    <Typography fontSize={13} fontWeight={700} color="#006D77">
                      {cart.length} Test{cart.length > 1 ? "s" : ""} Selected
                    </Typography>
                    <Typography fontSize={10} color="#888" noWrap sx={{ maxWidth: 200 }}>
                      {cart.slice(0, 2).map((t) => t.test_name).join(", ")}{cart.length > 2 ? ` +${cart.length - 2} more` : ""}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ textAlign: "right" }}>
                  <Typography fontSize={16} fontWeight={800} color="#006D77">₹{calcTotal().toFixed(2)}</Typography>
                  <Button size="small" onClick={() => setStep(2)}
                    sx={{ fontSize: 10, color: "#006D77", textTransform: "none", p: 0, minWidth: "auto", textDecoration: "underline" }}>
                    Edit Cart
                  </Button>
                </Box>
              </Box>

              <Typography fontWeight={800} fontSize={16} color="#1a1a1a" mb={2.5}>
                Patient Details & Appointment Time
              </Typography>

              {userLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                  <CircularProgress sx={{ color: "#006D77" }} />
                </Box>
              ) : (
                <CommonFieldsScreen
                  userData={user}
                  serviceData={{
                    serviceTitle: "DIAGNOSTIC SAMPLE COLLECTION",
                    serviceImage: DiagnosticSample,
                    servicePrice: calcTotal(),
                    orderType: "diagnostic",
                    diagnosticOrderData: {
                      tests: cart.map((t) => ({
                        test_id: t.id, test_code: t.test_code,
                        test_name: t.test_name, mrp: t.mrp,
                        proposed_rate: t.proposed_rate,
                        non_membership: t.non_membership,
                        category: t.category,
                      })),
                      total_amount: calcTotal(),
                      mrp_total: calcMRP(),
                      savings: calcSavings(),
                    },
                  }}
                />
              )}
            </Box>
          )}
        </Container>
      </Box>

      {/* Floating cart */}
      {step === 1 && <CartBar cart={cart} onViewCart={() => setStep(2)} />}

      <Footer />
    </>
  );
};

export default DiagnosticDeliveryScreen;